export const TYPE = Symbol('@type');
export const INCLUDED = Symbol('@included');
export const META = Symbol('@meta');
export const LINKS = Symbol('@links');
export const RELATIONSHIPS = Symbol('@relationships');
export const REFERENCES = Symbol('@references');
export const ID = Symbol('@id');
